// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomInfinity = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '14',
      height: '8',
      viewBox: '0 0 14 8',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.334 0.666992C8.93799 0.666992 7.92666 1.71166 6.99999 2.89766C6.07333 1.71166 5.06266 0.666992 3.66733 0.666992C1.82933 0.666992 0.333994 2.16233 0.333994 4.00033C0.332923 4.43775 0.418301 4.87107 0.585223 5.27539C0.752146 5.67971 0.997321 6.04706 1.30666 6.35633C1.61478 6.66698 1.98153 6.91335 2.38562 7.08112C2.78972 7.2489 3.22312 7.33474 3.66066 7.33366H3.66866C5.06133 7.33033 6.07199 6.28566 6.99933 5.09966C7.92666 6.28766 8.93799 7.33366 10.334 7.33366C12.172 7.33366 13.6673 5.83833 13.6673 4.00033C13.6673 2.16233 12.172 0.666992 10.334 0.666992ZM3.66599 6.00033L3.66066 6.66699V6.00033C3.12799 6.00033 2.62733 5.79233 2.25133 5.41499C1.97266 5.13471 1.78316 4.77823 1.70668 4.39046C1.63021 4.00269 1.6702 3.60096 1.82159 3.23586C1.97299 2.87077 2.22904 2.55863 2.55748 2.33877C2.88593 2.11891 3.27209 2.00115 3.66733 2.00033C4.55399 2.00033 5.37399 2.95899 6.16466 3.99899C5.37266 5.03833 4.55266 5.99833 3.66599 6.00033ZM10.334 6.00033C9.44733 6.00033 8.62666 5.04033 7.83466 3.99899C8.62599 2.95899 9.44599 2.00033 10.334 2.00033C11.4367 2.00033 12.334 2.89766 12.334 4.00033C12.334 5.10299 11.4367 6.00033 10.334 6.00033Z',
      fill: 'currentColor',
    }),
  );

export { IconCustomInfinity };
